export default __webpack_public_path__ + "5981e757a102fa5586a8b3eef40e21e2.svg";